/* eslint-disable react/jsx-props-no-spreading */
import Button from '../../atoms/button/Button';
import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import styles from './CollectionTile.module.scss';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { ResponsiveImage } from '../../atoms/image/ResponsiveImage';

const CollectionTile = (props) => {
  const {
    image,
    label,
    title,
    buttons,
    className,
    defaultRatio = 1.35,
    notActive,
  } = props;
  // default aspect ratio 3:4
  const [ratio, setRatio] = useState(defaultRatio);

  useEffect(() => {
    if (image && image.ratio) {
      const [w, h] = image.ratio.split(':').map(Number);
      setRatio(h / w);
    }
  }, [image]);

  return (
    <div
      className={`${styles.root} ${className}
      ${notActive && styles.notActiveSlide}
      `}
    >
      <div className={styles.image} style={{ '--ratio': ratio }}>
        <ResponsiveImage source={image} />
      </div>
      <div className={styles.content}>
        <div className={styles.textBlock}>
          <Text
            as="span"
            align="center"
            weight="normal"
            textTransform="uppercase"
            className={styles.label}
          >
            {label}
          </Text>
          <Heading
            as="p"
            styleAs="h1"
            textTransform="uppercase"
            weight="light"
            customClasses={{
              common_h1: styles.common_h1,
            }}
          >
            {title}
          </Heading>
        </div>
        <div className={styles.buttons}>
          {Array.isArray(buttons) &&
            buttons.length &&
            buttons.map((it, index) => (
              <Button
                nodeLink={it?.buttonUrl && it.buttonUrl}
                isInverted={true}
                shape="square"
                variant={it.buttonType}
                key={index}
              >
                <Button.Label>{it.buttonTitle}</Button.Label>
              </Button>
            ))}
        </div>
      </div>
    </div>
  );
};

export default CollectionTile;

CollectionTile.propTypes = {
  image: PropTypes.object.isRequired,
  label: PropTypes.string,
  title: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      variant: PropTypes.string,
      isOutlined: PropTypes.bool,
      isInverted: PropTypes.bool,
      as: PropTypes.string,
      text: PropTypes.string,
      size: PropTypes.string,
      href: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

CollectionTile.defaultProps = {
  label: '',
  title: '',
  buttons: [],
  className: '',
};
